import { createMuiTheme } from "@material-ui/core";
import { corporate } from "./colors";

export * from "./colors";

const themeSpacing = 8;

const lightenDarkenColor = (col, amt) => {
  let usePound = false;

  if (col[0] === "#") {
    col = col.slice(1);
    usePound = true;
  }

  let num = parseInt(col,16);

  let r = (num >> 16) + amt;
  if (r > 255) r = 255;
  else if  (r < 0) r = 0;

  let b = ((num >> 8) & 0x00FF) + amt;
  if (b > 255) b = 255;
  else if  (b < 0) b = 0;

  let g = (num & 0x0000FF) + amt;
  if (g > 255) {
    g = 255;
  } else if (g < 0) {
    g = 0;
  }

  return (usePound?"#":"") + String("000000" + (g | (b << 8) | (r << 16)).toString(16)).slice(-6);
};

export const createTheme = () => {
  return createMuiTheme({
    spacing: themeSpacing,
    zIndex: {
      appBar: 1100,
      modal: 1250,
      drawer: 1200,
      snackbar: 1400,
      tooltip: 1500
    },
    overrides: {
      MuiPopover: {
        root: {
          "z-index": "1300 !important"
        }
      },
      MuiTooltip: {
        tooltip: {
          backgroundColor: "rgba(0, 0, 0, 0.7)",
        },
        arrow: {
          "&::before": {
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            border: "0px"
          }
        },
      },
      MuiDialogTitle: {
        root: {
          padding: `${themeSpacing}px`,
          '& h2': {
            fontSize: "1.0rem !important"
          }
        }
      },
      MuiDialogContent: {
        root: {
          padding: `${2*themeSpacing}px`,
        }
      },
      MuiIconButton: {
        root: {
          padding: `${themeSpacing}px`
        }
      }
    },
    palette: {
      primary: {
        main: corporate.blue,
        light: lightenDarkenColor(corporate.blue, 25),
        dark: lightenDarkenColor(corporate.blue, -25)
      },
      secondary: {
        main: corporate.red,
        light: lightenDarkenColor(corporate.red, 25),
        dark: lightenDarkenColor(corporate.red, -25)
      }
    },
    mixins: {
      toolbar: {
        // override default
      }
    }
  });
};
